const state = {
    title: '',
    firstName: '',
    lastName: '',
    postcode: '',
    locationId: false,
    brand: '',
    email: '',
    telephone: '',
};

if (window.preloadedUser) {
    state.title = window.preloadedUser.title;
    state.firstName = window.preloadedUser.first_name;
    state.lastName = window.preloadedUser.last_name;
    state.locationId = window.preloadedUser.location_id;
    state.email = window.preloadedUser.email;
    state.telephone = window.preloadedUser.tel;
}

const getters = {
    name(state) {
        let names = [];
        if (state.title !== '') {
            names.push(state.title);
        }
        if (state.firstName !== '') {
            names.push(state.firstName);
        }
        if (state.lastName !== '') {
            names.push(state.lastName);
        }
        if (names.length == 0) {
            return 'Customer';
        }
        return names.join(' ');
    },
    customerData(state) {
        return {
            title: state.title,
            firstName: state.firstName,
            lastName: state.lastName,
            postcode: state.postcode,
            locationId: state.locationId,
            brand: state.brand,
            email: state.email,
            telephone: state.telephone,
        }
    },
};

const actions = {
    initialize({ commit, state }) {
        if (state.initialized) {
            return;
        }
        if (typeof sessionStorage == 'undefined') {
            return;
        }
        if (window.preloadedUser) {
            commit('setCustomerData', {
                title : window.preloadedUser.title,
                firstName : window.preloadedUser.first_name,
                lastName : window.preloadedUser.last_name,
                locationId : window.preloadedUser.location_id,
                email : window.preloadedUser.email,
                telephone : window.preloadedUser.tel,
            });
        } else {
            let customerData = sessionStorage.getItem('customerData');
            if (customerData == '' || customerData == null) {
                return;
            }
            customerData = JSON.parse(customerData);
            commit('setCustomerData', customerData);
        }
    },
    storeCustomerData({commit, getters}, data) {
        if (typeof sessionStorage == 'undefined') {
            return;
        }
        commit('setCustomerData', data);
        sessionStorage.setItem('customerData', JSON.stringify(getters.customerData));
    },
    updateCustomerData({commit}) {
        commit('setCustomerData', {
            title : window.preloadedUser.title,
            firstName : window.preloadedUser.first_name,
            lastName : window.preloadedUser.last_name,
            locationId : window.preloadedUser.location_id,
            email : window.preloadedUser.email,
            telephone : window.preloadedUser.tel,
        });
    },

};

const mutations = {
    setInitialized(state, value) {
        state.initialized = value;
    },
    setCustomerData(state, data) {
        state.title = (typeof data.title !== 'undefined') ? data.title : state.title;
        state.firstName = (typeof data.firstName !== 'undefined') ? data.firstName : state.firstName;
        state.firstName = (typeof data.first_name !== 'undefined') ? data.first_name : state.firstName;
        state.firstName = (typeof data['first-name'] !== 'undefined') ? data['first-name'] : state.firstName;
        state.lastName = (typeof data.lastName !== 'undefined') ? data.lastName : state.lastName;
        state.lastName = (typeof data.last_name !== 'undefined') ? data.last_name : state.lastName;
        state.lastName = (typeof data['last-name'] !== 'undefined') ? data['last-name'] : state.lastName;
        state.postcode = (typeof data.postcode !== 'undefined') ? data.postcode : state.postcode;
        state.locationId = (typeof data.locationId !== 'undefined') ? data.locationId : state.locationId;
        state.locationId = (typeof data['location-id'] !== 'undefined') ? data['location-id'] : state.locationId;
        state.brand = (typeof data.brand !== 'undefined') ? data.brand : state.brand;
        state.email = (typeof data.email !== 'undefined') ? data.email : state.email;
        state.telephone = (typeof data.telephone !== 'undefined') ? data.telephone : state.telephone;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};